import { Reveal } from "@/lib/reveal";
import { SectionMarker } from "@/components/SectionMarker";

export const WhatIsAiga = () => {
  return (
    <section id="about" className="relative py-20 lg:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <Reveal>
              <SectionMarker n="01" label="Aiga Enable" />
              <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
                What is Aiga Enable?
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6 space-y-5">
            <Reveal delay={0.05}>
              <p className="text-lg text-slate-200 leading-relaxed">
                Aiga Enable is an accessibility technology company helping people with disabilities
                communicate their accessibility needs, while giving organisations and services the
                information they need to better understand and support them — in advance.
              </p>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="text-lg text-slate-300 leading-relaxed">
                We are building the digital infrastructure for a more connected accessibility
                ecosystem, making accessibility information easier to manage, communicate and share
                across different services, organisations and everyday experiences.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="text-lg text-slate-300 leading-relaxed">
                Our goal is to help create a world where accessibility needs can be understood,
                giving people with disabilities greater confidence to access the world, while giving
                organisations and services the opportunity to be prepared rather than reactive.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
